import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { headerData_about, headerData_contactUs, headerData_engineStatus, headerData_hyundai, headerData_liebherr, headerData_promotion } from "../../../../data/headerData";
import { getCookie } from "../../../../util/cookie/cookies";
import { Lang } from "./lang";

const Header_Pc = () => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const lang = getCookie('HYUNDAILANG')
    const [isAcitve , setIsActive] = useState<boolean>(false)
    return(
        <>
        <div className="header_pc active">
            <h1>
                <span onClick={()=>navigate('/')}>
                    logo
                </span>
            </h1>

            <div>
                <nav>
                    <ul>
                        <li>
                            <span>{lang==='kr'?'회사소개':'Company'}</span>
                        </li>
                        <li>
                            <span></span>
                        </li>
                        <li>
                            <span></span>
                        </li>
                        <li>
                            <span>{lang==='kr'?'설비현황':'Facility status'}</span>
                        </li>
                        <li>
                            <span>{lang==='kr'?'홍보센터':'Promotion Center'}</span>
                        </li>
                        <li>
                            <span>{lang==='kr'?'고객센터':'Customer Center'}</span>
                        </li>
                    </ul>
                    <div className="megaMenu">
                        <ul>
                            <li>
                                <ul>
                                    <li className="none">
                                        <span>{lang==='kr'?'회사소개':'Company'}</span>
                                    </li>
                                    {headerData_about.map((list:any) => (
                                        <li onClick={()=>navigate(list?.url)}>
                                            <span>{lang==='kr'?list.title_kr : list?.title_en}</span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="none">
                                        <span>
                                            <img src="/assets/images/liebherr_logo_sub.png" alt="liebherr logo"/>
                                        </span>
                                    </li>
                                    {headerData_liebherr.map((list:any) => (
                                        <li onClick={()=>navigate(list.url)}>
                                            <span>{lang==='kr'?list.title_kr : list?.title_en}</span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="none">
                                        <span>
                                            <img src="/assets/images/hyundai_logo_sub.png" alt="hyundai logo"/>
                                        </span>
                                    </li>
                                    {headerData_hyundai.map((list:any) => (
                                        <li onClick={()=>navigate(list.url)}>
                                            <span>{lang==='kr'?list.title_kr : list?.title_en}</span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    {headerData_engineStatus.map((list:any) => (
                                        <li className="none" onClick={()=>navigate(list.url)}>
                                            <span>{lang==='kr'?list.title_kr : list?.title_en}</span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="none">
                                        <span>{lang==='kr'?'홍보센터':'Promotion Center'}</span>
                                    </li>
                                    {headerData_promotion.map((list:any) => (
                                        <li onClick={()=>navigate(list.url)}>
                                            <span>{lang==='kr'?list.title_kr : list?.title_en}</span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li className="none">
                                        <span>{lang==='kr'?'고객센터':'Customer Center'}</span>
                                    </li>
                                    {headerData_contactUs.map((list:any) => (
                                        <li onClick={()=>navigate(list.url)}>
                                            <span>{lang==='kr'?list.title_kr : list?.title_en}</span>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                        </ul>
                    </div>
                </nav>
                <Lang/>
            </div>
        </div>
        </>
    )
}

export default Header_Pc;